import { render, staticRenderFns } from "./UnitServiceOrderHistoryManualComponent.vue?vue&type=template&id=1f156b4d&"
import script from "./UnitServiceOrderHistoryManualComponent.vue?vue&type=script&lang=js&"
export * from "./UnitServiceOrderHistoryManualComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports